import {css} from "@emotion/react";

import {pb} from "@pg-design/helpers-css-strings";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import SlickSlider from "@pg-mono/slick-slider";

import {slickSlider} from "../../../app/styles/slick_slider";
import {getRequestStateFromRtkQuery} from "../../../store/utils/get_request_state_from_rtk_query";
import {useGetOfferListQuery} from "../../api/get_offer_list";
import {OfferBoxPlaceholder} from "../../atoms/OfferBoxPlaceholder";
import {OfferBoxWithOfferDetailsAction} from "../../atoms/OfferBoxWithOfferDetailsAction";
import {carouselSliderSettings} from "../../constants/carousel_slider_settings";
import {IOfferBox} from "../offer_box/OfferBox";
import {OfferModal} from "../offer_modal/OfferModal";

interface IProps {
    offerIds: number[];
    gtmMeta: IOfferBox["gtmMeta"];
}

export const RelatedOfferCarouselWithModal = (props: IProps) => {
    const {offerIds} = props;
    const {data, isUninitialized, isSuccess, isError, isLoading, isFetching} = useGetOfferListQuery(
        {
            page: 1,
            page_size: 20,
            include_offer: offerIds
        },
        {
            skip: !offerIds.length || offerIds.length === 0
        }
    );

    return (
        <div css={carouselWrapper}>
            <SlickSlider {...carouselSliderSettings}>
                {!!data && data.results.length > 0
                    ? data.results.map((offer, index) => {
                          return <OfferBoxWithOfferDetailsAction key={offer.id} offer={offer} index={index} gtmMeta={props.gtmMeta} />;
                      })
                    : Array.from({length: 4}).map((_, index) => {
                          return <OfferBoxPlaceholder key={index} />;
                      })}
            </SlickSlider>

            <OfferModal
                modalName="mainOfferModal"
                offersQuery={{
                    data: data?.results || [],
                    isInitialized: !isUninitialized,
                    isSuccess,
                    isError,
                    isLoading,
                    count: data?.count || 0,
                    page: data?.page || 1,
                    pageSize: data?.page_size || 20,
                    requestState: getRequestStateFromRtkQuery({isFetching, isSuccess, isError, isLoading})
                }}
            />
        </div>
    );
};

const carouselWrapper = css`
    ${slickSlider};
    .slick-list {
        ${pb(3)};

        .slick-track {
            display: flex;

            .slick-slide:not(:first-of-type) {
                padding: 0 1.6rem;
            }

            @media (min-width: ${getThemeBreakpoint().xs}) {
                .slick-slide {
                    padding: 0 1.6rem;
                }
            }
            @media (max-width: ${getThemeBreakpoint().xs}) {
                .slick-slide {
                    max-width: 330px;
                }
            }
        }
    }

    .slick-next {
        width: 20px;
        &::before {
            right: -1rem;
            transform: translate(0, -20px);
        }
    }

    .slick-prev {
        width: 20px;
        &::before {
            left: -1rem;
            transform: translate(0, -20px);
        }
    }
`;
import {css} from "@emotion/react";

import {pb} from "@pg-design/helpers-css-strings";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import SlickSlider from "@pg-mono/slick-slider";

import {slickSlider} from "../../../app/styles/slick_slider";
import {getRequestStateFromRtkQuery} from "../../../store/utils/get_request_state_from_rtk_query";
import {useGetOfferListQuery} from "../../api/get_offer_list";
import {OfferBoxPlaceholder} from "../../atoms/OfferBoxPlaceholder";
import {OfferBoxWithOfferDetailsAction} from "../../atoms/OfferBoxWithOfferDetailsAction";
import {carouselSliderSettings} from "../../constants/carousel_slider_settings";
import {IOfferBox} from "../offer_box/OfferBox";
import {OfferModal} from "../offer_modal/OfferModal";

interface IProps {
    offerIds: number[];
    gtmMeta: IOfferBox["gtmMeta"];
}

export const RelatedOfferCarouselWithModal = (props: IProps) => {
    const {offerIds} = props;
    const {data, isUninitialized, isSuccess, isError, isLoading, isFetching} = useGetOfferListQuery(
        {
            page: 1,
            page_size: 20,
            include_offer: offerIds
        },
        {
            skip: !offerIds.length || offerIds.length === 0
        }
    );

    return (
        <div css={carouselWrapper}>
            <SlickSlider {...carouselSliderSettings}>
                {!!data && data.results.length > 0
                    ? data.results.map((offer, index) => {
                          return <OfferBoxWithOfferDetailsAction key={offer.id} offer={offer} index={index} gtmMeta={props.gtmMeta} />;
                      })
                    : Array.from({length: 4}).map((_, index) => {
                          return <OfferBoxPlaceholder key={index} />;
                      })}
            </SlickSlider>

            <OfferModal
                modalName="mainOfferModal"
                offersQuery={{
                    data: data?.results || [],
                    isInitialized: !isUninitialized,
                    isSuccess,
                    isError,
                    isLoading,
                    count: data?.count || 0,
                    page: data?.page || 1,
                    pageSize: data?.page_size || 20,
                    requestState: getRequestStateFromRtkQuery({isFetching, isSuccess, isError, isLoading})
                }}
            />
        </div>
    );
};

const carouselWrapper = css`
    ${slickSlider};
    .slick-list {
        ${pb(3)};

        .slick-track {
            display: flex;

            .slick-slide:not(:first-of-type) {
                padding: 0 1.6rem;
            }

            @media (min-width: ${getThemeBreakpoint().xs}) {
                .slick-slide {
                    padding: 0 1.6rem;
                }
            }
            @media (max-width: ${getThemeBreakpoint().xs}) {
                .slick-slide {
                    max-width: 330px;
                }
            }
        }
    }

    .slick-next {
        width: 20px;
        &::before {
            right: -1rem;
            transform: translate(0, -20px);
        }
    }

    .slick-prev {
        width: 20px;
        &::before {
            left: -1rem;
            transform: translate(0, -20px);
        }
    }
`;
